import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chart-bar",
  "use": "chart-bar-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"chart-bar\"><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M20 0C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0zm0 37.6a17.6 17.6 0 110-35.3 17.6 17.6 0 010 35.3zM18.8 15.3h2.4v10.1h-2.4zM26.3 8h2.4v17.4h-2.4zM11.3 20.5h2.4v4.9h-2.4zM8.8 27.6h22.4v2H8.8z\" class=\"st0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol